import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const LadderIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.8618 1.27639C7.94649 1.107 8.11962 1 8.30901 1H9.19098C9.56267 1 9.80441 1.39116 9.63819 1.72361L8.99999 3H12L12.8618 1.27639C12.9465 1.107 13.1196 1 13.309 1H14.191C14.5627 1 14.8044 1.39116 14.6382 1.72361L8.13819 14.7236C8.05349 14.893 7.88036 15 7.69098 15H6.80901C6.43732 15 6.19557 14.6088 6.3618 14.2764L7.24999 12.5H4.24999L3.13819 14.7236C3.05349 14.893 2.88036 15 2.69098 15H1.80901C1.43732 15 1.19557 14.6088 1.3618 14.2764L7.8618 1.27639ZM4.99999 11H7.99999L9.24999 8.5H6.24999L4.99999 11ZM11.25 4.5L9.99999 7H6.99999L8.24999 4.5H11.25Z"
		></path>
	</svg>
))
